<template>
  <div class="gestion-usuarios-v2">

    <!-- ============ DASHBOARD HEADER ============ -->
    <div class="gu-dash-header">
      <div class="gu-dash-top">
        <div>
          <div class="gu-eyebrow">USERS · ACCESS CONTROL</div>
          <h2 class="gu-title">Gestión de usuarios</h2>
        </div>
      </div>

      <div class="gu-kpi-strip">
        <div class="gu-kpi-card">
          <div class="gu-kpi-label">USUARIOS</div>
          <div class="gu-kpi-value">{{ kpiTotal }}</div>
          <div class="gu-kpi-foot">
            <span class="gu-dot gu-dot-blue"></span>
            <span>en el sistema</span>
          </div>
        </div>
        <div class="gu-kpi-card">
          <div class="gu-kpi-label">ACTIVOS</div>
          <div class="gu-kpi-value">{{ kpiActivos }}</div>
          <div class="gu-kpi-foot">
            <span class="gu-dot gu-dot-green pulse"></span>
            <span>con acceso</span>
          </div>
        </div>
        <div class="gu-kpi-card">
          <div class="gu-kpi-label">INACTIVOS</div>
          <div class="gu-kpi-value">{{ kpiInactivos }}</div>
          <div class="gu-kpi-foot">
            <span class="gu-dot gu-dot-red"></span>
            <span>deshabilitados</span>
          </div>
        </div>
        <div class="gu-kpi-card">
          <div class="gu-kpi-label">CON LLAVE RFID</div>
          <div class="gu-kpi-value">{{ kpiConLlave }}</div>
          <div class="gu-kpi-foot">
            <span class="gu-dot gu-dot-orange"></span>
            <span>fichaje habilitado</span>
          </div>
        </div>
      </div>
    </div>

    <!-- ============ CREAR USUARIO ============ -->
    <b-card no-body class="crear-usuario-card mb-2">
      <b-card-header class="crear-usuario-header">
        <div class="d-flex align-items-center">
          <div class="crear-usuario-icon mr-1">
            <feather-icon icon="UserPlusIcon" size="20" />
          </div>
          <div>
            <h5 class="mb-0">Crear nuevo usuario</h5>
            <small class="text-muted">Rellena los datos para dar de alta un nuevo usuario</small>
          </div>
        </div>
      </b-card-header>
      <b-card-body>
        <b-form @submit.prevent="crearUsuario">
          <!-- Datos personales -->
          <div class="form-section-label mb-75 mt-1">
            <feather-icon icon="UserIcon" size="14" class="mr-50" />
            Datos personales
          </div>
          <b-row>
            <b-col md="3">
              <b-form-group class="mb-1">
                <label class="form-label-custom">Nombre <span class="text-danger">*</span></label>
                <b-form-input v-model="nuevoUsuario.nombre" required placeholder="Nombre" class="input-custom" />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group class="mb-1">
                <label class="form-label-custom">Nombre Completo</label>
                <b-form-input v-model="nuevoUsuario.nombreCompleto" placeholder="Nombre y apellidos" class="input-custom" />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group class="mb-1">
                <label class="form-label-custom">NIF</label>
                <b-form-input v-model="nuevoUsuario.nif" placeholder="12345678A" class="input-custom" />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group class="mb-1">
                <label class="form-label-custom">N. Seguridad Social</label>
                <b-form-input v-model="nuevoUsuario.numeroSS" placeholder="12 12345678 90" class="input-custom" />
              </b-form-group>
            </b-col>
          </b-row>

          <hr class="form-divider">

          <!-- Acceso -->
          <div class="form-section-label mb-75">
            <feather-icon icon="ShieldIcon" size="14" class="mr-50" />
            Acceso y permisos
          </div>
          <b-row class="align-items-end">
            <b-col md="4">
              <b-form-group class="mb-1">
                <label class="form-label-custom">Email <span class="text-danger">*</span></label>
                <div class="input-icon-wrapper">
                  <feather-icon icon="MailIcon" size="16" class="input-icon-left" />
                  <b-form-input v-model="nuevoUsuario.user" type="email" required placeholder="usuario@email.com" class="input-custom input-with-icon" />
                </div>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group class="mb-1">
                <label class="form-label-custom">Password <span class="text-danger">*</span></label>
                <div class="input-icon-wrapper">
                  <feather-icon icon="LockIcon" size="16" class="input-icon-left" />
                  <b-form-input v-model="nuevoUsuario.pass" type="password" required placeholder="Contraseña segura" class="input-custom input-with-icon" />
                </div>
              </b-form-group>
            </b-col>
            <b-col md="4" class="d-flex align-items-end">
              <b-button variant="outline-primary" @click="abrirModalPermisosNuevo" class="mb-1 btn-permisos" block>
                <feather-icon icon="ShieldIcon" size="16" class="mr-50" />
                Seleccionar permisos
                <b-badge v-if="nuevoUsuario.permisos && nuevoUsuario.permisos.length" variant="primary" pill class="ml-50">
                  {{ nuevoUsuario.permisos.length }}
                </b-badge>
              </b-button>
            </b-col>
          </b-row>

          <hr class="form-divider">

          <div class="d-flex justify-content-end">
            <b-button type="submit" variant="primary" class="btn-crear-usuario">
              <feather-icon icon="UserPlusIcon" size="16" class="mr-50" />
              Crear usuario
            </b-button>
          </div>
        </b-form>
      </b-card-body>
    </b-card>

    <div class="gu-list-panel">
      <div class="gu-list-header">
        <div class="gu-list-title">
          <feather-icon icon="UsersIcon" size="14" />
          <span>Listado de usuarios</span>
        </div>
        <div class="gu-list-meta">
          <span class="gu-list-count">{{ usuarios.length }}</span>
          <span class="gu-list-count-txt">total</span>
        </div>
      </div>
      <b-table :items="usuarios" :fields="columnasTable" class="tabla-usuarios" hover responsive
        sort-icon-left :tbody-tr-class="rowClass">

        <template #cell(nombre)="data">
          <strong>{{ data.item.nombre }}</strong>
          <small v-if="data.item.nombreCompleto" class="d-block text-muted">{{ data.item.nombreCompleto }}</small>
        </template>

        <template #cell(llave)="data">
          <b-badge v-if="data.item.llave" variant="light-success">
            <i class="fa-solid fa-id-card mr-25"></i> Asignada
          </b-badge>
          <span v-else class="text-muted">—</span>
        </template>

        <template #cell(calendario)="data">
          <b-badge :variant="data.item.calendario ? 'light-success' : 'light-secondary'">
            {{ data.item.calendario ? 'Si' : 'No' }}
          </b-badge>
        </template>

        <template #cell(estado)="data">
          <b-badge :variant="data.item.activo ? 'light-success' : 'light-danger'">
            {{ data.item.activo ? 'Activo' : 'Inactivo' }}
          </b-badge>
        </template>

        <template #cell(totpActivo)="data">
          <b-badge :variant="data.item.totpActivo ? 'light-success' : 'light-secondary'">
            {{ data.item.totpActivo ? 'Si' : 'No' }}
          </b-badge>
          <b-button v-if="data.item.totpActivo" variant="flat-danger" size="sm" class="btn-icon ml-25"
            @click="quitar2fa(data.item)" v-b-tooltip.hover.top title="Desactivar 2FA (móvil perdido)">
            <i class="fa-solid fa-shield-halved"></i>
          </b-button>
        </template>

        <template #cell(acciones)="data">
          <div class="acciones-usuarios">
            <b-button variant="flat-info" size="sm" class="btn-icon" @click="abrirModalEditar(data.item)"
              v-b-tooltip.hover.top title="Editar">
              <i class="fa-solid fa-pen"></i>
            </b-button>
            <b-button variant="flat-primary" size="sm" class="btn-icon" @click="abrirModalPermisos(data.item)"
              v-b-tooltip.hover.top title="Permisos">
              <i class="fa-solid fa-lock"></i>
            </b-button>
            <b-button variant="flat-secondary" size="sm" class="btn-icon" @click="abrirModalPassword(data.item)"
              v-b-tooltip.hover.top title="Contraseña">
              <i class="fa-solid fa-key"></i>
            </b-button>
            <b-button variant="flat-warning" size="sm" class="btn-icon" @click="abrirModalLlave(data.item)"
              v-b-tooltip.hover.top title="Llave RFID">
              <i class="fa-solid fa-id-card"></i>
            </b-button>
            <b-button :variant="data.item.calendario ? 'flat-success' : 'flat-secondary'" size="sm" class="btn-icon"
              @click="toggleCalendario(data.item)" v-b-tooltip.hover.top :title="data.item.calendario ? 'Quitar de calendario' : 'Añadir a calendario'">
              <i class="fa-solid fa-calendar-days"></i>
            </b-button>
            <b-button :variant="data.item.b2bAcceso ? 'flat-success' : 'flat-secondary'" size="sm" class="btn-icon"
              @click="abrirModalB2b(data.item)" v-b-tooltip.hover.top
              :title="data.item.b2bAcceso ? `Web wholesale: acceso activo (WSP ${data.item.b2bWspPct || 40}%)` : 'Dar acceso a la web wholesale (misma contraseña que el ERP)'">
              <i class="fa-solid fa-globe"></i>
            </b-button>
            <b-button v-if="data.item.activo" variant="flat-danger" size="sm" class="btn-icon"
              @click="toggleActivo(data.item, false)" v-b-tooltip.hover.top title="Desactivar">
              <i class="fa-solid fa-user-xmark"></i>
            </b-button>
            <b-button v-else variant="flat-success" size="sm" class="btn-icon"
              @click="toggleActivo(data.item, true)" v-b-tooltip.hover.top title="Activar">
              <i class="fa-solid fa-user-check"></i>
            </b-button>
          </div>
        </template>

      </b-table>
    </div>


    <b-modal id="modalPermisos" :title="tituloModalPermisos" hide-footer>
      <template v-for="(grupo, i) in navigation">
      <div v-if="Array.isArray(grupo.children) && grupo.children.length" :key="grupo.header || i" class="mb-1">
        <h5 class="mb-2">
          <i :class="grupo.icon" class="mr-2"></i>{{ grupo.header || 'Sección' }}
        </h5>

        <b-form-checkbox-group v-model="permisosTemp" :name="`permisos-${slugify(grupo.header || i)}`" stacked>
          <template v-for="c in grupo.children">
          <b-form-checkbox v-if="c && typeof c.route === 'string' && c.route.length" :key="c.route" :value="c.route">
            <i :class="c.icon" class="mr-1"></i>{{ c.title || c.route }}
          </b-form-checkbox>
          </template>
        </b-form-checkbox-group>

        <hr>
      </div>
      </template>

      <b-button variant="primary" block @click="guardarPermisos">
        Guardar permisos
      </b-button>
    </b-modal>

    <b-modal id="modalB2b" title="Acceso web wholesale" hide-footer centered>
      <p class="text-muted mb-1">
        Entra en la web con su usuario y contraseña del ERP. El % WSP es el porcentaje
        del RRP que paga (40 = paga el 40%).
      </p>
      <b-form-group label="% WSP">
        <b-form-input v-model.number="b2bPct" type="number" min="1" max="100" step="0.5" />
      </b-form-group>
      <b-button variant="primary" block @click="guardarB2b(true)">
        {{ usuarioSeleccionado && usuarioSeleccionado.b2bAcceso ? 'Guardar cambios' : 'Dar acceso' }}
      </b-button>
      <b-button v-if="usuarioSeleccionado && usuarioSeleccionado.b2bAcceso" variant="outline-danger" block @click="guardarB2b(false)">
        Quitar acceso
      </b-button>
    </b-modal>

    <b-modal id="modalPassword" title="Cambiar contraseña" hide-footer centered>
      <b-form @submit.prevent="guardarPassword">
        <b-form-group label="Nueva contraseña">
          <b-form-input v-model="nuevaPassword" type="password" required placeholder="Introduce la nueva contraseña" />
        </b-form-group>

        <b-button type="submit" variant="primary" block>
          Guardar contraseña
        </b-button>
      </b-form>
    </b-modal>

    <b-modal id="modalEditar" title="Editar Usuario" hide-footer centered size="lg">
      <b-form @submit.prevent="guardarEdicion">
        <b-row>
          <b-col md="6">
            <b-form-group label="Nombre">
              <b-form-input v-model="usuarioEditar.nombre" required />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Nombre Completo">
              <b-form-input v-model="usuarioEditar.nombreCompleto" placeholder="Nombre y apellidos" />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="4">
            <b-form-group label="NIF">
              <b-form-input v-model="usuarioEditar.nif" placeholder="12345678A" />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Nº Seguridad Social">
              <b-form-input v-model="usuarioEditar.numeroSS" placeholder="12 12345678 90" />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Email">
              <b-form-input v-model="usuarioEditar.user" type="email" required />
            </b-form-group>
          </b-col>
        </b-row>

        <div class="d-flex justify-content-end mt-2">
          <b-button variant="outline-secondary" class="mr-2" @click="$bvModal.hide('modalEditar')">
            Cancelar
          </b-button>
          <b-button type="submit" variant="primary">
            <i class="fa-solid fa-save mr-1"></i> Guardar cambios
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modalLlave" title="Asignar Llave RFID" hide-footer centered @shown="iniciarEscuchaRFID"
      @hidden="detenerEscuchaRFID">
      <div class="text-center py-4">
        <div class="rfid-icon mb-3" :class="{ 'rfid-success': nuevaLlave }">
          <i class="fa-solid fa-id-card" style="font-size: 4rem"></i>
        </div>

        <div v-if="!nuevaLlave" class="mb-3">
          <p class="text-muted mb-1">Esperando lectura de tarjeta...</p>
          <div class="rfid-pulse">
            <i class="fa-solid fa-wifi fa-rotate-90"></i>
          </div>
        </div>

        <div v-else class="mb-3">
          <p class="text-success mb-1">
            <i class="fa-solid fa-check-circle mr-1"></i> Tarjeta detectada
          </p>
          <div class="llave-display">
            <span v-for="n in nuevaLlave.length" :key="n">•</span>
          </div>
        </div>

        <hr>

        <div class="d-flex justify-content-between">
          <b-button variant="outline-secondary" @click="nuevaLlave = ''">
            <i class="fa-solid fa-rotate-left mr-1"></i> Limpiar
          </b-button>
          <b-button variant="warning" @click="guardarLlave" :disabled="!nuevaLlave">
            <i class="fa-solid fa-save mr-1"></i> Guardar
          </b-button>
        </div>
      </div>
    </b-modal>


  </div>
</template>

<script>
import axios from '@axios'
import vSelect from 'vue-select'
import navigation from '@/navigation/horizontal'
import { VBTooltip } from 'bootstrap-vue'

export default {
  components: {
    vSelect,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      navigation,
      columnasTable: [{
        key: "acciones",
        label: "",
        thStyle: { width: "200px" },
      }, {
        key: "nombre",
        label: "Nombre",
        sortable: true,
      }, {
        key: "user",
        label: "Email",
        sortable: true,
      }, {
        key: "llave",
        label: "Llave",
        sortable: true,
        thStyle: { width: "120px", textAlign: "center" },
        tdClass: "text-center",
      }, {
        key: "calendario",
        label: "Calendario",
        sortable: true,
        thStyle: { width: "120px", textAlign: "center" },
        tdClass: "text-center",
      }, {
        key: "totpActivo",
        label: "2FA",
        sortable: true,
        thStyle: { width: "100px", textAlign: "center" },
        tdClass: "text-center",
      }, {
        key: "estado",
        label: "Estado",
        thStyle: { width: "100px", textAlign: "center" },
        tdClass: "text-center",
      }],
      usuarios: [],
      nuevoUsuario: {
        nombre: '',
        nombreCompleto: '',
        nif: '',
        numeroSS: '',
        user: '',
        pass: '',
        permisos: []
      },
      permisosTemp: [],
      usuarioSeleccionado: null,
      nuevaPassword: '',
      b2bPct: 40,
      nuevaLlave: '',
      rfidBuffer: '',
      rfidTimeout: null,
      usuarioEditar: {
        id: null,
        nombre: '',
        nombreCompleto: '',
        nif: '',
        numeroSS: '',
        user: ''
      },
    }
  },
  computed: {
    tituloModalPermisos() {
      return this.usuarioSeleccionado
        ? `Permisos de ${this.usuarioSeleccionado.nombre}`
        : 'Permisos';
    },
    kpiTotal() {
      return (this.usuarios || []).length;
    },
    kpiActivos() {
      return (this.usuarios || []).filter(u => u && u.activo).length;
    },
    kpiInactivos() {
      return (this.usuarios || []).filter(u => u && !u.activo).length;
    },
    kpiConLlave() {
      return (this.usuarios || []).filter(u => u && u.llave).length;
    },
  },
  methods: {
    load() {
      axios.post("/uso", { seccion: "gestion-usuarios" });
      axios
        .get("/usuarios")
        .then(response => {
          return response.data;
        })
        .then(res => {
          this.usuarios = res;
        });
    },
    async toggleCalendario(usuario) {
      const nuevoEstado = usuario.calendario ? 0 : 1;
      try {
        await axios.put(`/usuarios/${usuario.id}/calendario`, { calendario: nuevoEstado });
        usuario.calendario = nuevoEstado;
      } catch (error) {
        console.error(error);
        this.$bvToast.toast('Error al actualizar el calendario del usuario', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      }
    },
    abrirModalB2b(usuario) {
      this.usuarioSeleccionado = usuario
      this.b2bPct = Number(usuario.b2bWspPct) || 40
      this.$bvModal.show('modalB2b')
    },
    async guardarB2b(activo) {
      const usuario = this.usuarioSeleccionado;
      try {
        await axios.put(`/usuarios/${usuario.id}/b2b`, { activo: activo ? 1 : 0, pct: this.b2bPct });
        this.$set(usuario, 'b2bAcceso', activo ? 1 : 0);
        this.$set(usuario, 'b2bWspPct', this.b2bPct);
        this.$bvModal.hide('modalB2b');
        this.$bvToast.toast(activo
          ? `${usuario.nombre} puede entrar en la web wholesale (WSP ${this.b2bPct}%)`
          : `Acceso a la web wholesale retirado a ${usuario.nombre}`, {
          title: 'Web wholesale',
          variant: 'success',
          solid: true
        });
      } catch (error) {
        console.error(error);
        this.$bvToast.toast('Error al actualizar el acceso a la web wholesale', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      }
    },
    async quitar2fa(usuario) {
      const ok = await this.$bvModal.msgBoxConfirm(
        `${usuario.nombre} podrá entrar solo con su contraseña hasta que vuelva a activar el 2FA. ¿Continuar?`,
        { title: 'Desactivar 2FA', okTitle: 'Desactivar', okVariant: 'danger', cancelTitle: 'Cancelar', centered: true }
      );
      if (!ok) return;
      try {
        await axios.put(`/usuarios/${usuario.id}/2fa`);
        this.$set(usuario, 'totpActivo', 0);
        this.$bvToast.toast(`2FA desactivado para ${usuario.nombre}`, { title: 'Éxito', variant: 'success', solid: true });
      } catch (error) {
        console.error(error);
        this.$bvToast.toast('Error al desactivar el 2FA', { title: 'Error', variant: 'danger', solid: true });
      }
    },
    async toggleActivo(usuario, activar) {
      const nuevoEstado = activar ? 1 : 0;
      try {
        await axios.put(`/usuarios/${usuario.id}/activo`, { activo: nuevoEstado });
        usuario.activo = nuevoEstado;
      } catch (error) {
        console.error(error);
        this.$bvToast.toast('Error al actualizar el estado del usuario', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      }
    },
    rowClass(item) {
      if (!item) return '';
      return item.activo ? '' : 'usuario-inactivo';
    },
    async crearUsuario() {

      const permisosJSON = {};
      this.todasLasRutas().forEach(route => {
        permisosJSON[route] = this.permisosTemp.includes(route);
      });

      try {
        await axios.post('/usuarios', {
          nombre: this.nuevoUsuario.nombre,
          nombreCompleto: this.nuevoUsuario.nombreCompleto,
          nif: this.nuevoUsuario.nif,
          numeroSS: this.nuevoUsuario.numeroSS,
          user: this.nuevoUsuario.user,
          pass: this.nuevoUsuario.pass,
          permisos: permisosJSON,
        });

        this.$bvToast.toast('Usuario creado correctamente', {
          title: 'Éxito',
          variant: 'success',
          solid: true
        });

        this.nuevoUsuario = { nombre: '', nombreCompleto: '', nif: '', numeroSS: '', user: '', pass: '', permisos: [] };
        this.load();
      } catch (error) {
        console.error(error);
        this.$bvToast.toast('Error al crear el usuario', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      }
    },
    slugify(str) {
      return String(str)
        .toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    },

    abrirModalPermisos(usuario) {
      this.usuarioSeleccionado = usuario;
      this.permisosTemp = [];

      // Cargar marcados existentes -> array de routes
      if (usuario.permisos) {
        const p = typeof usuario.permisos === 'string'
          ? JSON.parse(usuario.permisos)
          : usuario.permisos;

        this.permisosTemp = Object.keys(p).filter(k => p[k] === true);
      }

      this.$bvModal.show('modalPermisos');
    },

    // Obtiene TODAS las rutas definidas en navigation (para construir el objeto final)
    todasLasRutas() {
      const rutas = [];
      this.navigation.forEach(g => {
        if (Array.isArray(g.children)) {
          g.children.forEach(c => {
            if (c && typeof c.route === 'string' && c.route.length) {
              rutas.push(c.route);
            }
          });
        }
      });
      return Array.from(new Set(rutas));
    },
    async guardarPermisos() {

      if (this.usuarioSeleccionado === null) {

        this.nuevoUsuario.permisos = this.permisosTemp;
        this.$bvModal.hide('modalPermisos');
        return;
      }

      const permisosJSON = {};
      this.todasLasRutas().forEach(route => {
        permisosJSON[route] = this.permisosTemp.includes(route);
      });


      try {
        await axios.put(`/usuarios/${this.usuarioSeleccionado.id}`, {
          permisos: permisosJSON,
        });
        this.$bvToast.toast('Permisos actualizados correctamente', {
          title: 'Éxito', variant: 'success', solid: true
        });
        this.$bvModal.hide('modalPermisos');
      } catch (e) {
        console.error(e);
        this.$bvToast.toast('Error al guardar permisos', {
          title: 'Error', variant: 'danger', solid: true
        });
      }
    },
    abrirModalPermisosNuevo() {
      this.usuarioSeleccionado = null;
      this.permisosTemp = this.nuevoUsuario.permisos;
      this.$bvModal.show('modalPermisos');
    },
    abrirModalPassword(usuario) {
      this.usuarioSeleccionado = usuario
      this.nuevaPassword = ''
      this.$bvModal.show('modalPassword')
    },
    async guardarPassword() {

      try {
        await axios.post('/usuarios/password', {
          id: this.usuarioSeleccionado.id,
          pass: this.nuevaPassword,
        })

        this.$bvToast.toast('Contraseña actualizada correctamente', {
          title: 'Éxito',
          variant: 'success',
          solid: true,
        })
        this.$bvModal.hide('modalPassword')
      } catch (error) {
        console.error(error)
        this.$bvToast.toast('Error al cambiar la contraseña', {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
      }
    },
    abrirModalLlave(usuario) {
      this.usuarioSeleccionado = usuario
      this.nuevaLlave = ''
      this.$bvModal.show('modalLlave')
    },
    iniciarEscuchaRFID() {
      this.rfidBuffer = ''
      this.rfidTimeout = null
      window.addEventListener('keypress', this.capturarRFID)
    },
    detenerEscuchaRFID() {
      window.removeEventListener('keypress', this.capturarRFID)
      if (this.rfidTimeout) clearTimeout(this.rfidTimeout)
    },
    capturarRFID(event) {
      // Ignorar si hay un input activo
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') return

      // Los lectores RFID envían caracteres rápidamente y terminan con Enter
      if (event.key === 'Enter') {
        if (this.rfidBuffer.length > 0) {
          this.nuevaLlave = this.rfidBuffer
          this.rfidBuffer = ''
        }
        return
      }

      this.rfidBuffer += event.key

      // Reset timeout - si pasan más de 100ms sin teclas, limpiar buffer
      if (this.rfidTimeout) clearTimeout(this.rfidTimeout)
      this.rfidTimeout = setTimeout(() => {
        this.rfidBuffer = ''
      }, 100)
    },
    async guardarLlave() {
      try {
        const response = await axios.put(`/usuarios/${this.usuarioSeleccionado.id}/llave`, {
          llave: this.nuevaLlave
        })

        this.usuarioSeleccionado.llave = this.nuevaLlave

        this.$bvToast.toast('Llave actualizada correctamente', {
          title: 'Éxito',
          variant: 'success',
          solid: true,
        })
        this.$bvModal.hide('modalLlave')
      } catch (error) {
        console.error(error)
        const mensaje = error.response?.data?.msg || 'Error al guardar la llave'
        this.$bvToast.toast(mensaje, {
          title: 'Error',
          variant: 'danger',
          solid: true,
        })
        this.nuevaLlave = ''
      }
    },
    abrirModalEditar(usuario) {
      this.usuarioEditar = {
        id: usuario.id,
        nombre: usuario.nombre || '',
        nombreCompleto: usuario.nombreCompleto || '',
        nif: usuario.nif || '',
        numeroSS: usuario.numeroSS || '',
        user: usuario.user || ''
      }
      this.$bvModal.show('modalEditar')
    },
    async guardarEdicion() {
      try {
        await axios.put(`/usuarios/${this.usuarioEditar.id}`, {
          nombre: this.usuarioEditar.nombre,
          nombreCompleto: this.usuarioEditar.nombreCompleto,
          nif: this.usuarioEditar.nif,
          numeroSS: this.usuarioEditar.numeroSS,
          user: this.usuarioEditar.user
        })

        this.$bvToast.toast('Usuario actualizado correctamente', {
          title: 'Éxito',
          variant: 'success',
          solid: true
        })
        this.$bvModal.hide('modalEditar')
        this.load()
      } catch (error) {
        console.error(error)
        this.$bvToast.toast('Error al actualizar el usuario', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      }
    }
  },
  mounted() {
    this.load();
  }
}
</script>

<style lang="scss">
@import '../@core/scss/vue/libs/vue-select.scss';
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500;600;700&display=swap');

// ===== Design tokens (Data-Dense Dashboard) =====
$gu-primary: #3B82F6;
$gu-primary-soft: #60A5FA;
$gu-cta: #F97316;
$gu-bg: #F8FAFC;
$gu-surface: #FFFFFF;
$gu-border: #E2E8F0;
$gu-text: #1E293B;
$gu-text-mute: #64748B;
$gu-text-soft: #94A3B8;

.gestion-usuarios-v2 {
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  padding-bottom: 24px;

  // ===== HEADER =====
  .gu-dash-header {
    background: $gu-surface;
    border: 1px solid $gu-border;
    border-radius: 14px;
    padding: 18px 20px 14px;
    margin-bottom: 16px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  }

  .gu-dash-top { margin-bottom: 18px; }

  .gu-eyebrow {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    font-weight: 600;
    color: $gu-primary;
    letter-spacing: 0.14em;
    margin-bottom: 4px;

    &::before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      background: $gu-cta;
      border-radius: 50%;
      margin-right: 6px;
      vertical-align: middle;
      animation: gu-pulse 2s infinite;
    }
  }

  .gu-title {
    font-size: 22px;
    font-weight: 700;
    margin: 0;
    color: $gu-text;
    letter-spacing: -0.01em;
  }

  // ===== KPI STRIP =====
  .gu-kpi-strip {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;

    @media (max-width: 900px) { grid-template-columns: repeat(2, 1fr); }
    @media (max-width: 480px) { grid-template-columns: 1fr; }
  }

  .gu-kpi-card {
    background: $gu-bg;
    border: 1px solid $gu-border;
    border-radius: 10px;
    padding: 12px 14px;
    transition: all 200ms ease;

    &:hover {
      border-color: $gu-primary-soft;
      box-shadow: 0 2px 8px rgba(59, 130, 246, 0.08);
    }
  }

  .gu-kpi-label {
    font-family: 'JetBrains Mono', monospace;
    font-size: 9.5px;
    font-weight: 600;
    color: $gu-text-soft;
    letter-spacing: 0.12em;
    margin-bottom: 6px;
  }

  .gu-kpi-value {
    font-family: 'JetBrains Mono', monospace;
    font-size: 26px;
    font-weight: 700;
    color: $gu-text;
    line-height: 1.1;
    margin-bottom: 6px;
    font-feature-settings: "tnum", "zero";
  }

  .gu-kpi-foot {
    font-size: 10.5px;
    color: $gu-text-mute;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .gu-dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
  }
  .gu-dot-blue { background: $gu-primary; }
  .gu-dot-orange { background: $gu-cta; }
  .gu-dot-green { background: #10B981; }
  .gu-dot-red { background: #EF4444; }
  .gu-dot.pulse { animation: gu-pulse 2s infinite; }

  // ===== LIST PANEL =====
  .gu-list-panel {
    background: $gu-surface;
    border: 1px solid $gu-border;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  }

  .gu-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 18px;
    background: $gu-bg;
    border-bottom: 1px solid $gu-border;
  }

  .gu-list-title {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    font-weight: 600;
    color: $gu-text-mute;
    letter-spacing: 0.08em;
    text-transform: uppercase;

    svg { color: $gu-primary; }
  }

  .gu-list-meta {
    display: inline-flex;
    align-items: baseline;
    gap: 6px;
    padding: 5px 12px;
    background: $gu-surface;
    border: 1px solid $gu-border;
    border-radius: 8px;
  }
  .gu-list-count {
    font-family: 'JetBrains Mono', monospace;
    font-size: 13px;
    font-weight: 700;
    color: $gu-primary;
  }
  .gu-list-count-txt {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10.5px;
    color: $gu-text-soft;
  }

  // ===== TABLE OVERRIDES =====
  .tabla-usuarios {
    margin-bottom: 0 !important;
    background: $gu-surface;

    thead th {
      font-family: 'JetBrains Mono', monospace !important;
      font-size: 10px !important;
      font-weight: 600 !important;
      color: $gu-text-soft !important;
      letter-spacing: 0.08em !important;
      text-transform: uppercase;
      background: $gu-surface !important;
      border-bottom: 1px solid $gu-border !important;
      border-top: 0 !important;
      padding: 14px 16px !important;
    }

    tbody tr {
      transition: background 150ms ease;

      td {
        border-top: 1px solid $gu-border !important;
        font-size: 13px;
        color: $gu-text;
      }

      &:hover { background: rgba(59, 130, 246, 0.04) !important; }
    }
  }

  @keyframes gu-pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.55; transform: scale(0.85); }
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      transition-duration: 0.01ms !important;
    }
  }
}

// ===== DARK MODE =====
.dark-layout .gestion-usuarios-v2 {
  .gu-dash-header,
  .gu-list-panel { background: #242424; border-color: #3b3b3b; }
  .gu-title { color: #e4e6eb; }

  .gu-kpi-card {
    background: #1f1f1f;
    border-color: #3b3b3b;
    &:hover { border-color: $gu-primary; }
  }
  .gu-kpi-value { color: #e4e6eb; }
  .gu-kpi-label, .gu-list-title { color: #6e7079; }

  .gu-list-header { background: #1f1f1f; border-bottom-color: #3b3b3b; }
  .gu-list-meta { background: #242424; border-color: #3b3b3b; }

  .tabla-usuarios {
    background: #242424;

    thead th {
      background: #242424 !important;
      border-bottom-color: #3b3b3b !important;
      color: #6e7079 !important;
    }
    tbody tr {
      td { border-top-color: #3b3b3b !important; color: #d0d2d6; }
      &:hover { background: rgba(59, 130, 246, 0.08) !important; }
    }
  }
}

// Formulario crear usuario
.crear-usuario-card {
  border: none;
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);

  .crear-usuario-header {
    border-bottom: 1px solid #f3f2f7;
    padding: 1.2rem 1.5rem;
  }

  .crear-usuario-icon {
    width: 42px;
    height: 42px;
    border-radius: 10px;
    background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }

  .form-section-label {
    font-size: 0.8rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #a0a0a0;
    display: flex;
    align-items: center;
  }

  .form-label-custom {
    font-size: 0.857rem;
    font-weight: 600;
    color: #5e5873;
    margin-bottom: 0.35rem;
    display: block;
  }

  .input-custom {
    border-radius: 8px;
    border: 1px solid #ebe9f1;
    transition: border-color 0.2s, box-shadow 0.2s;

    &:focus {
      border-color: #7367f0;
      box-shadow: 0 3px 10px 0 rgba(115, 103, 240, 0.15);
    }
  }

  .input-icon-wrapper {
    position: relative;

    .input-icon-left {
      position: absolute;
      left: 12px;
      top: 50%;
      transform: translateY(-50%);
      color: #b4b7bd;
      z-index: 2;
    }

    .input-with-icon {
      padding-left: 38px;
    }
  }

  .form-divider {
    border-color: #f3f2f7;
    margin: 0.75rem 0;
  }

  .btn-permisos {
    border-radius: 8px;
    font-weight: 500;
    border-style: dashed;
    border-width: 2px;
    transition: all 0.2s;

    &:hover {
      border-style: solid;
    }
  }

  .btn-crear-usuario {
    border-radius: 8px;
    padding: 0.65rem 2rem;
    font-weight: 500;
    letter-spacing: 0.3px;
  }
}

.tabla-usuarios {
  margin-bottom: 0;

  th {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #888;
    font-weight: 600;
  }

  td {
    vertical-align: middle !important;
    padding: 10px 12px !important;
  }
}

.acciones-usuarios {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-wrap: nowrap;
}

.usuario-inactivo {
  background-color: rgba(232, 48, 48, 0.295) !important;
  opacity: 0.7;
  color: rgba(0, 0, 0, 0.671);
}

.rfid-icon {
  color: #6c757d;
  transition: all 0.3s ease;
}

.rfid-icon.rfid-success {
  color: #28c76f;
}

.rfid-pulse {
  animation: pulse 1.5s infinite;
  color: #7367f0;
  font-size: 1.5rem;
}

@keyframes pulse {
  0% {
    opacity: 0.3;
    transform: scale(0.95);
  }

  50% {
    opacity: 1;
    transform: scale(1.05);
  }

  100% {
    opacity: 0.3;
    transform: scale(0.95);
  }
}

.llave-display {
  font-size: 1.5rem;
  letter-spacing: 3px;
  color: #28c76f;
}

</style>